import { render } from "./averageGeneral.vue?vue&type=template&id=f068981a"
import script from "./averageGeneral.vue?vue&type=script&lang=js"
export * from "./averageGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__